<template>
    <div class="loader" v-bind:class="{ 'active' : getLoader}">
        <div>
            <img src="@/assets/audi.png" alt="Audi Poznań" class="img-responsive" >
            <p>Ładowanie...</p>
        </div>
    </div>
</template>

<script>


import { mapGetters } from 'vuex'

export default {
  name: 'loader',
  computed: {
      ...mapGetters(['getLoader'])
  }
}
</script>

<style lang="scss" scoped>
    .loader{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: rgba($color: #000000, $alpha: .6);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-weight:bold;
        transition: all .5s;
        opacity: 0;
        height: 0px;
        overflow: hidden;
        &.active{
            opacity: 1;
            height: 100%;
            bottom: 0;
                    padding:6rem;
        }
        img{
            filter: invert(1);
        }
    }
</style>
